export default __webpack_public_path__ + "static/media/51_4_1.6fdacfc9.png";